module.exports = __webpack_public_path__ + "2b3fd015c91ba62566e72ac1ce976f3d.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/headscarf-s.png
// module id = 2304
// module chunks = 0